var exports = {
  "k": "xa15a2ab7--fed5ad--container",
};

module.exports = exports;
